const constants = {
  apiUrl: "http://localhost:5000",
};

export default constants;
